import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
const CreateVehicleComponent = loadable(
  () => import("../../components/Vehicle/CreateVehicle")
);
const CreateVehicle = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["vehicle"],
    navigateURL: "/vehicle",
  });

  const { data: defaultVehicleCategory, isLoading: isdefaultLoading } =
    useGetHook({
      queryKey: ["vehicle-category"],
      url: APIS.VEHILCE_CATEGORY,
      params: {
        is_default: true,
      },
    });
  const { data: defaultVehicleType, isLoading: isLoading } = useGetHook({
    queryKey: ["vehicle-type"],
    url: APIS.VEHILCE_TYPE,
    params: {
      is_default: true,
    },
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.VEHILCE}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div
        className={tw`"w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Vehicle
        </span>
      </div>
      {isLoading || isdefaultLoading ? (
        <Spinner />
      ) : (
        <CreateVehicleComponent
          isLoading={isPostLoading}
          handleCreate={handleCreate}
          defaultVehicleCategory={defaultVehicleCategory}
          defaultVehicleType={defaultVehicleType}
        />
      )}
    </>
  );
};

export default CreateVehicle;
